import React from 'react';
import {Radio, Input, Modal} from 'antd';
import { observer } from "mobx-react";
import { translateText, getDirection} from "../../stores/objects/I18n"

const TranslationsView = observer(class TranslationsView extends React.Component{


  radioStyle = {
    display: 'block',
    width: '90%',
    height: '30px',
    lineHeight: '30px'
  }

  state = {
    radioValue: 0,
    userInput: null,
  };


renderResult(r, i) {
    return (
        <Radio style={this.radioStyle} value={i} key={i}>
            <span>
            {r['translation']}
            </span>
        </Radio>
    );
}

onRadioChange = e => {
    this.setState({
        radioValue: e.target.value,
    });
  };

onUserInput = e => {
    this.setState({
        userInput: e.target.value,
    });
  };

onOK = () => {
    this.props.store.state.awaitingUserSelection = false;
    let value =  
        (this.state.radioValue === this.props.store.translator.results.length ?
            this.state['userInput'] :
            this.props.store.translator.results[this.state.radioValue]['translation']) 
    this.props.store.translator.selectedTranslation = value;
    this.props.store.search(value, this.props.store);
}

renderWithoutResults() {
    return (<p>
        {translateText(this.props.store, "No translation found. Please provide your own translation:")}
        <Input style={{ width: 100, marginLeft: 10 }}
        onChange={this.onUserInput} />
    </p>)
}

renderWithResults() {
    return (<Radio.Group onChange={this.onRadioChange} value={this.state.radioValue} 
             className={this.props.store.state.accessibilityEnabled ? "orkr-radio-accessible" : ""}>
        {this.props.store.translator.results.map((r, i) => 
            (this.renderResult(r,i))
        )}
    <Radio style={this.radioStyle}  value={this.props.store.translator.results.length}>
    {translateText(this.props.store, "Provide your own translation:")}
      {this.state.radioValue === this.props.store.translator.results.length ? 
      <Input style={{ width: 100, marginLeft: 10 }} 
             onChange={this.onUserInput}/> : 
      null}
    </Radio>
  </Radio.Group>);
}

renderModal() {
    return this.props.store.translator.results.length === 0 ?
            this.renderWithoutResults() :
            this.renderWithResults();
}

render() {
  return (
      <Modal title={translateText(this.props.store, "Possible Translations:")}
            visible={this.props.store.state.awaitingUserSelection}  
            okText={translateText(this.props.store, "OK")}
            cancelText={translateText(this.props.store, "Cancel")}
            onOk={this.onOK}
            onCancel={() => {this.props.store.state.awaitingUserSelection = false}}
            role="complementary"
            className={"CSUS-SE-"+getDirection(this.props.store)+
                       (this.props.store.state.accessibilityEnabled ? " CSUS-SE-accessible" : "")}>
        {this.renderModal()}
      </Modal>
    );
}  

});
  
export default TranslationsView;
